import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import React, { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { ProgressBar } from "primereact/progressbar";
import { Tag } from "primereact/tag";
import "./branchTarget.css";
import cup from "../../../assets/branchRanking/ChatGPT Image Sep 5, 2026, 10_02_30 PM 1 (1).png"
import SeptemberPODashboard from "../../achiversGridImage/SeptemberPODashboard";
import { BranchPerGrid } from "../../achiversGridImage/BranchPerGrid";
import FinalDayDashboard from "../../achiversGridImage/FinalDayDashboard";
import { ILogin } from "../../../models/Login";
import MissionDashboard from "../../achiversGridImage/MissionDashboard";
import MotivationDashboard from "../../achiversGridImage/OctoberBranchCard";
// import BarchTargetAchiversView from "../../achiversGridImage/BarchTargetAchiversView";
// import BranchPerformanceDashboard from "../../achiversGridImage/BranchPerformanceDashboard";

interface IBranchTargetsReport {
    branchName?: string,
    company_Name?: string,
    min_Target?: number,
    max_Target?: number,
    no_Of_POs?: number,
    shortfall?: number,
    status?: string,
    reamrk?: string,
}

interface BranchReport {
    company_name: string;
    branch: string;
    no_of_users_contribution: number;
    users: {
        name: string;
    }[];
}

interface CompanyContribution {
    name: string;
    achieved: number;
    min: number;
    max: number;
}

interface Branch {
    name: string;
    achieved: number;
    minTarget: number;
    maxTarget: number;
    color: string;
    companies: CompanyContribution[];
}

interface Performer {
    name: string;
    initials: string;
    company: string;
    branch: string;
    po: number;
    badge: string;
    badgeType:
    | "champion"
    | "highFlyer"
    | "hotStreak"
    | "powerPlayer"
    | "steadyDriver"
    | "risingStar";
    week1_PO?: number,
    week2_PO?: number,
    week3_PO?: number,
    week4_PO?: number,
    week5_PO?: number,
    login_ID?: number,
}

interface LeaderboardPerformer {
    name: string;
    initials: string;
    todayPO: number;
}

interface UserPerformance {
    name: string;
    totalPO: number;
    weeklyPO: {
        week: string;
        value: number;
    }[];
}

export const BranchTargetReport = () => {
    const [showBranch, setShowBranch] = useState({ open: false, branchName: "" } as { open: boolean, branchName: string });
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchTargetsReport>, loading: boolean });
    const [tableData2, setTableData2] = useState({ tableData: [], loading: false } as { tableData: Array<IBranchTargetsReport>, loading: boolean });
    const [tableData3, setTableData3] = useState({ tableData: [], loading: false } as { tableData: Array<BranchReport>, loading: boolean });
    const [tableDataBranches, setTableDataBranches] = useState({ tableData: [], loading: false } as { tableData: Branch[], loading: boolean });
    const [tableDataPerformers, setTableDataPerformers] = useState({ tableData: [], loading: false } as { tableData: LeaderboardPerformer[], loading: boolean });
    const [isPerformers, setIsPerformers] = useState({
        name: "User",
        totalPO: 0,
        weeklyPO: [{ week: "W1", value: 0, }, { week: "W2", value: 0, }, { week: "W3", value: 0, }, { week: "W4", value: 0, }, { week: "W5", value: 0, },]
    } as UserPerformance);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const headerGroup = (
        <ColumnGroup>
            {/* First header row */}
            <Row>
                <Column header="SN" rowSpan={1} />
                <Column header="Company & Consultant#" headerStyle={{
                    backgroundColor: "#bbd0fd",
                    paddingLeft: "3%",
                    fontWeight: "bolder"
                }} colSpan={2} />
                <Column header="Consultant Activities" headerStyle={{
                    backgroundColor: "#a8f6b0",
                    paddingLeft: "3%",
                    fontWeight: "bolder"
                }} colSpan={2} />
                <Column header="Subvendor Activities" headerStyle={{
                    backgroundColor: "#f9cb9c",
                    paddingLeft: "3%",
                    fontWeight: "bolder"
                }} colSpan={2} />
                <Column header="Inhouse Activities" headerStyle={{
                    backgroundColor: "#fa9bf2",
                    paddingLeft: "3%",
                    fontWeight: "bolder"
                }} colSpan={2} />
                <Column header="Pending Summary" headerStyle={{
                    backgroundColor: "#f9f497",
                    paddingLeft: "8%",
                    fontWeight: "bolder"
                }} colSpan={3} />
            </Row>

            {/* Second header row */}
            <Row>
                <Column header="" />

                <Column header="Company Name" headerStyle={{
                    backgroundColor: "#bbd0fd",
                    textAlign: "center"
                }} />
                <Column header="Consultant#" headerStyle={{
                    backgroundColor: "#bbd0fd",
                    textAlign: "center"
                }} />

                <Column header="Consultant#" headerStyle={{
                    backgroundColor: "#a8f6b0",
                    textAlign: "center"
                }} />
                <Column header="Timesheet#" headerStyle={{
                    backgroundColor: "#a8f6b0",
                    textAlign: "center"
                }} />

                <Column header="Consultant#" headerStyle={{
                    backgroundColor: "#f9cb9c",
                    textAlign: "center"
                }} />
                <Column header="Timesheet#" headerStyle={{
                    backgroundColor: "#f9cb9c",
                    textAlign: "center"
                }} />

                <Column header="Consultant#" headerStyle={{
                    backgroundColor: "#fa9bf2",
                    textAlign: "center"
                }} />
                <Column header="Timesheet#" headerStyle={{
                    backgroundColor: "#fa9bf2",
                    textAlign: "center"
                }} />

                <Column header="Consultant#" headerStyle={{
                    backgroundColor: "#f9f497",
                    textAlign: "center"
                }} />
                <Column header="Timesheet#" headerStyle={{
                    backgroundColor: "#f9f497",
                    textAlign: "center"
                }} />
                <Column header="Status" headerStyle={{
                    backgroundColor: "#f9f497",
                    textAlign: "center"
                }} />
            </Row>
        </ColumnGroup>
    );

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
            </React.Fragment>
        );
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setTableData2({ tableData: [], loading: false });
        const response = await Fetch("Requirement_MAST/branchTarget", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchTargetsReport> = await response.json();
            const sortedBranches = [...data].sort((a, b) => {

                const percentageA = Number(a.max_Target || "0") > 0
                    ? Number(a.no_Of_POs || "0") / Number(a.max_Target || "0")
                    : 0;

                const percentageB = Number(b.max_Target || "0") > 0
                    ? Number(b.no_Of_POs || "0") / Number(b.max_Target || "0")
                    : 0;

                // Primary: performance percentage
                if (percentageB !== percentageA) {
                    return percentageB - percentageA;
                }

                // Secondary: actual achievement
                return Number(b.no_Of_POs || "0") - Number(a.no_Of_POs || "0");
            });
            setTableData({ tableData: sortedBranches, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const loadTableData3 = async () => {
        setTableData3({ tableData: tableData3.tableData, loading: true });
        const response = await Fetch("Requirement_MAST/getBranchTargetCompletedUsers", "GET", null, null, null);
        if (response) {
            const data: Array<BranchReport> = await response.json();
            setTableData3({ tableData: data, loading: false });
        } else setTableData3({ tableData: tableData3.tableData, loading: false });
    }

    const loadTableData2 = async (branchName: string) => {
        setTableData2({ tableData: tableData2.tableData, loading: true });
        const response2 = await Fetch("Requirement_MAST/branchSpecificTarget", "GET", null, `branchName=${branchName}`, null);
        if (response2) {
            const data: Array<IBranchTargetsReport> = await response2.json();
            setTableData2({ tableData: data, loading: false });
        } else {
            setTableData2({ tableData: tableData2.tableData, loading: false });
        }
    }

    const getProgress = (row: IBranchTargetsReport) => {
        if (!row.min_Target) return 0;

        return Math.min(
            Math.round((Number(row.no_Of_POs || "0") / Number(row.min_Target || "0")) * 100),
            100
        );
    };

    const getStatus = (row: IBranchTargetsReport) => {
        const progress = getProgress(row);

        if (Number(row.no_Of_POs || "0") >= Number(row.max_Target || "0")) {
            return {
                label: 'Outstanding',
                severity: 'success',
                className: 'status-outstanding'
            };
        }

        if (Number(row.no_Of_POs || "0") >= Number(row.max_Target || "0")) {
            return {
                label: 'Target Achieved',
                severity: 'success',
                className: 'status-achieved'
            };
        }

        if (progress >= 70) {
            return {
                label: 'Almost There',
                severity: 'warning',
                className: 'status-warning'
            };
        }

        if (progress > 0) {
            return {
                label: 'In Progress',
                severity: 'info',
                className: 'status-progress'
            };
        }

        return {
            label: 'Needs Attention',
            severity: 'danger',
            className: 'status-danger'
        };
    };

    const branchTemplate = (row: IBranchTargetsReport) => {
        let data = {
            icon: "",
            branch: ""
        };
        if (row.branchName === "Agra") data = { icon: "🕌", branch: "Agra" };
        else if (row.branchName === "Bhubaneswar") data = { icon: "🛕", branch: "Bhubaneswar" };
        else if (row.branchName === "Varanasi") data = { icon: "🪔", branch: "Varanasi" };
        else if (row.branchName === "Ranchi") data = { icon: "💧", branch: "Ranchi" };
        else if (row.branchName === "Noida") data = { icon: "💻", branch: "Noida" };
        else if (row.branchName === "Meerut") data = { icon: "🏏", branch: "Meerut" };
        else if (row.branchName === "Lucknow") data = { icon: "🪡", branch: "Lucknow" };
        else if (row.branchName === "Jaipur") data = { icon: "🌸", branch: "Jaipur" };

        const status = getStatus(row);

        return (
            <div className="branch-cell" style={{ cursor: "pointer" }} onClick={() => {
                loadTableData2(row.branchName || "");
                setShowBranch({ open: true, branchName: row.branchName || "" });
            }}>
                <div className="branch-icon">
                    {data.icon}
                </div>
                <div className="branch-info">
                    <div className="branch-name">
                        {data.branch}
                    </div>
                    <div className="branch-subtitle">
                        Branch Performance
                    </div>
                </div>
            </div>
        );
    };

    const targetTemplate = (row: IBranchTargetsReport) => {
        return (
            <div className="target-cell">
                <div className="target-item minimum">
                    <span className="target-label">
                        MIN
                    </span>
                    <strong>
                        {row.min_Target}
                    </strong>
                </div>
                <div className="target-arrow">
                    →
                </div>
                <div className="target-item maximum">
                    <span className="target-label">
                        GOAL
                    </span>

                    <strong>
                        {row.max_Target}
                    </strong>
                </div>
            </div>
        );
    };

    const achievementTemplate = (row: IBranchTargetsReport) => {

        const progress = Math.min(
            Math.round((Number(row.no_Of_POs || "0") / Number(row.min_Target || "0")) * 100),
            100
        );

        return (
            <div className="achievement-cell">

                <div className="achievement-top">

                    <div>
                        <span className="achievement-label">
                            ACHIEVED
                        </span>

                        <div className="achievement-number">
                            {row.no_Of_POs}
                            <span>
                                / {row.min_Target}
                            </span>
                        </div>
                    </div>

                    <div className="achievement-percent">
                        {progress}%
                    </div>

                </div>

                <ProgressBar
                    value={progress}
                    showValue={false}
                    className="achievement-progress"
                />

                <div className="achievement-message">
                    {Number(row.no_Of_POs || "0") >= Number(row.min_Target || "0")
                        ? '🎉 Minimum target achieved!'
                        : `${Number(row.min_Target || "0") - Number(row.no_Of_POs || "0")} more to reach target`
                    }
                </div>

            </div>
        );
    };

    const shortfallTemplate = (row: IBranchTargetsReport) => {

        const shortfall = Math.max(
            (Number(row.no_Of_POs || "0") >= Number(row.min_Target || "0")) ? Number(row.max_Target || "0") - Number(row.no_Of_POs || "0") : Number(row.min_Target || "0") - Number(row.no_Of_POs || "0"),
            0
        );

        if (shortfall === 0) {
            return (
                <div className="shortfall-complete">
                    <span>✓</span>
                    <strong>0</strong>
                    <small>Target reached</small>
                </div>
            );
        }

        return (
            <div className="shortfall-cell">

                <div className="shortfall-icon">
                    ⚡
                </div>

                <div>
                    <strong>
                        {shortfall}
                    </strong>

                    <small>
                        {(Number(row.no_Of_POs || "0") >= Number(row.min_Target || "0")) ? "to maximum target" : "to minimum target"}
                    </small>
                </div>

            </div>
        );
    };

    const statusTemplate = (row: IBranchTargetsReport) => {

        const status = getStatus(row);

        //status.severity || 
        return (
            <Tag
                value={status.label}
                severity={"info"}
                className={`performance-tag ${status.className}`}
            />
        );
    };

    const remarkTemplate = (row: IBranchTargetsReport) => {

        const progress = getProgress(row);

        let remark = row.reamrk;

        if (!remark) {

            if (progress === 0) {
                remark = '🚀 Your journey starts here!';
            }
            else if (progress < 50) {
                remark = '💪 Keep pushing!';
            }
            else if (progress < 100) {
                remark = '🔥 Almost there!';
            }
            else {
                remark = '🏆 Excellent work!';
            }
        }

        return (
            <div className="remark-cell">
                {remark}
            </div>
        );
    };

    const showBranchName = (branch: string) => {
        if (branch === "Agra") return "🕌 Agra";
        else if (branch === "Bhubaneswar") return "🛕 Bhubaneswar";
        else if (branch === "Varanasi") return "🪔 Varanasi";
        else if (branch === "Ranchi") return "💧 Ranchi";
        else if (branch === "Noida") return "💻 Noida";
        else if (branch === "Meerut") return "🏏 Meerut";
        else if (branch === "Lucknow") return "🪡 Lucknow";
        else if (branch === "Jaipur") return "🌸 Jaipur";
    };

    const loadTableDataBranches = async () => {
        setTableDataBranches({ tableData: tableDataBranches.tableData, loading: true });
        const response = await Fetch("Requirement_MAST/getNewDashBranches", "GET", null, null, null);
        if (response) {
            const data: Array<Branch> = await response.json();
            setTableDataBranches({ tableData: data, loading: false });
        } else setTableDataBranches({ tableData: tableDataBranches.tableData, loading: false });
    }

    const loadTableDataPerformers = async () => {
        setTableDataPerformers({ tableData: tableDataPerformers.tableData, loading: true });
        const response = await Fetch("Requirement_MAST/getNewDashPerformers", "GET", null, null, null);
        if (response) {
            const data: Array<Performer> = await response.json();
            setTableDataPerformers({
                tableData: data.map((el: any) => {
                    return {
                        name: el.name,
                        initials: el.initials,
                        todayPO: el.po,
                    };
                }), loading: false
            });
            const performer: Performer[] = data.filter((el: Performer) => el.login_ID === loginObj.id);
            if (performer.length > 0) {
                setIsPerformers({
                    name: performer[0].name,
                    totalPO: performer[0].po,
                    weeklyPO: [
                        {
                            week: "W1",
                            value: (performer[0]?.week1_PO || 0),
                        },
                        {
                            week: "W2",
                            value: (performer[0]?.week2_PO || 0),
                        },
                        {
                            week: "W3",
                            value: (performer[0]?.week3_PO || 0),
                        },
                        {
                            week: "W4",
                            value: (performer[0]?.week4_PO || 0),
                        },
                        {
                            week: "W5",
                            value: (performer[0]?.week5_PO || 0),
                        },
                    ]
                });
            } else {
                setIsPerformers({
                    name: "User",
                    totalPO: 0,
                    weeklyPO: [
                        {
                            week: "W1",
                            value: 0,
                        },
                        {
                            week: "W2",
                            value: 0,
                        },
                        {
                            week: "W3",
                            value: 0,
                        },
                        {
                            week: "W4",
                            value: 0,
                        },
                        {
                            week: "W5",
                            value: 0,
                        },
                    ]
                });
            }
        } else setTableDataPerformers({ tableData: tableDataPerformers.tableData, loading: false });
    }

    useEffect(() => {
        loadTableData();
        // loadTableData3();
        // loadTableDataBranches();
        // loadTableDataPerformers();
    }, [])

    return (
        <>
            <MotivationDashboard />
            {/* <SeptemberPODashboard /> */}
            {/* <MissionDashboard /> */}
            {/* <BranchPerGrid /> */}
            {/* <FinalDayDashboard userPerformance={isPerformers} leaderboard={tableDataPerformers.tableData || []} branches={tableDataBranches.tableData || []} /> */}
            {/* <BranchPerformanceDashboard branches={tableData.tableData} reports={tableData3.tableData} /> */}
            {/* <BarchTargetAchiversView /> */}
            {/* 'linear-gradient(90deg, #ff3b3b, #ffb03b, #f4e04d, #3bd671, #3bb6ff, #a83bff, #ff3b8f, #ff3b3b)', */}
            {/* <>
                <style>{`
        @keyframes shimmerSweep {
          0% { background-position: -150% 0; }
          100% { background-position: 250% 0; }
        }
      `}</style>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '2.5rem 1rem',
                        background: '#0F1B2D',
                    }}
                >
                    <h1
                        style={{
                            margin: 0,
                            fontFamily: 'Georgia, serif',
                            fontWeight: 700,
                            fontSize: '36px',
                            textAlign: 'center',
                            lineHeight: 1.35,
                            background:
                                'linear-gradient(100deg, #E7E2D3 40%, #EFD98C 48%, #E7E2D3 56%)',
                            backgroundSize: '250% 100%',
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            color: 'transparent',
                            animation: 'shimmerSweep 4s ease-in-out infinite',
                        }}
                    >
                        Mission 251
                        <br />
                        The PO's Journey — September 2026
                    </h1>
                </div>
            </> */}
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                size="small" stripedRows showGridlines resizableColumns columnResizeMode="expand" scrollable scrollHeight="65vh"
                value={tableData.tableData}
                header={<p>All Branch Target Report</p>}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} body={(rowData, options) => options.rowIndex + 1} footer={() => { return <span className="font-bold" style={{ fontWeight: "bolder", fontSize: "20px" }}>Total</span> }} />
                <Column style={{ minWidth: "9rem" }} field="branchName" header="Branch" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} body={(rowData: IBranchTargetsReport) => <p className="cursor-pointer text-cyan-700" onClick={() => {
                    loadTableData2(rowData.branchName || "");
                    setShowBranch({ open: true, branchName: rowData.branchName || "" });

                }}>{showBranchName(rowData.branchName || "")}</p>} />
                <Column field="min_Target" header="Min Target" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} footer={() => {
                    const aeq = (tableData.tableData as any).reduce((sum: any, item: { min_Target: any; }) => sum + (item.min_Target || 0), 0);
                    return <span style={{ fontWeight: "bolder", fontSize: "20px" }}>{aeq}</span>;
                }} />
                <Column field="max_Target" header="Max Target" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} footer={() => {
                    const aeq = (tableData.tableData as any).reduce((sum: any, item: { max_Target: any; }) => sum + (item.max_Target || 0), 0);
                    return <span style={{ fontWeight: "bolder", fontSize: "20px" }}>{aeq}</span>;
                }} />
                <Column field="no_Of_POs" header="Achieved Target" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} footer={() => {
                    const aeq = (tableData.tableData as any).reduce((sum: any, item: { no_Of_POs: any; }) => sum + (item.no_Of_POs || 0), 0);
                    return <span style={{ fontWeight: "bolder", fontSize: "20px" }}>{aeq}</span>;
                }} />
                <Column field="shortfall" header="Shortfall" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} footer={() => {
                    const aeq = (tableData.tableData as any).reduce((sum: any, item: { shortfall: any; }) => sum + (item.shortfall || 0), 0);
                    return <span style={{ fontWeight: "bolder", fontSize: "20px" }}>{aeq}</span>;
                }} />
                <Column field="status" header="Status" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} />
                <Column field="reamrk" header="Remark" bodyStyle={{ fontWeight: "bolder", fontSize: "20px" }} headerStyle={{ fontWeight: "bolder", fontSize: "20px" }} />
            </DataTable>

            <Dialog visible={showBranch.open} style={{ width: '80vw' }} modal className="p-fluid" onHide={() => {
                setShowBranch({ open: false, branchName: "" });
                setTableData2({ tableData: [], loading: false });
            }}>
                {((tableData2.tableData.length > 0) || (tableData2.loading === true)) && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows showGridlines resizableColumns columnResizeMode="expand" scrollable scrollHeight="65vh"
                    value={tableData2.tableData}
                    header={<p>{showBranch.branchName} Branch Target Report</p>}
                    loading={tableData2.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => { return <span className="font-bold">Total</span> }} />
                    <Column field="company_Name" header="Company" />
                    <Column field="min_Target" header="Min Target" footer={() => {
                        const aeq = (tableData2.tableData as any).reduce((sum: any, item: { min_Target: any; }) => sum + (item.min_Target || 0), 0);
                        return <span className="font-bold">{aeq}</span>;
                    }} />
                    <Column field="max_Target" header="Max Target" footer={() => {
                        const aeq = (tableData2.tableData as any).reduce((sum: any, item: { max_Target: any; }) => sum + (item.max_Target || 0), 0);
                        return <span className="font-bold">{aeq}</span>;
                    }} />
                    <Column field="no_Of_POs" header="Achieved Target" footer={() => {
                        const aeq = (tableData2.tableData as any).reduce((sum: any, item: { no_Of_POs: any; }) => sum + (item.no_Of_POs || 0), 0);
                        return <span className="font-bold">{aeq}</span>;
                    }} />
                    <Column field="shortfall" header="Shortfall" footer={() => {
                        const aeq = (tableData2.tableData as any).reduce((sum: any, item: { shortfall: any; }) => sum + (item.shortfall || 0), 0);
                        return <span className="font-bold">{aeq}</span>;
                    }} />
                    <Column field="status" header="Status" />
                    <Column field="reamrk" header="Remark" />
                </DataTable>}
            </Dialog>
            <div className="mission-header">
                <div style={{ width: "100%", display: "flex", gap: "2rem", alignItems: "center" }}>
                    <div>
                        <img src={cup} height={"50px"} alt="cup" />
                    </div>
                    <div>
                        <div className="mission-title">
                            Mission 251
                        </div>
                        <div className="mission-subtitle">
                            The PO's Journey
                        </div>
                    </div>
                </div>

                <div className="mission-period">
                    October 2026
                </div>
            </div>

            <DataTable
                value={tableData.tableData}
                loading={tableData.loading}
                className="branch-target-table"
                rowHover
                showGridlines={false}
                stripedRows={false}
                responsiveLayout="scroll"
            >
                <Column
                    header="#"
                    body={(row, options) => options.rowIndex + 1}
                    style={{ width: '60px' }}
                />

                <Column
                    field="branch"
                    header="Branch"
                    body={branchTemplate}
                    style={{ minWidth: '220px' }}
                />

                <Column
                    header={<p>Target ({tableData.tableData.reduce(
                        (total: number, el: IBranchTargetsReport) => total + Number(el.min_Target || "0"),
                        0
                    )} → {tableData.tableData.reduce(
                        (total: number, el: IBranchTargetsReport) => total + Number(el.max_Target || "0"),
                        0
                    )})</p>}
                    body={targetTemplate}
                    style={{ minWidth: '190px' }}
                />

                <Column
                    header={<p>Achievement ({tableData.tableData.reduce(
                        (total: number, el: IBranchTargetsReport) => total + Number(el.no_Of_POs || "0"),
                        0
                    )})</p>}
                    body={achievementTemplate}
                    style={{ minWidth: '300px' }}
                />

                <Column
                    header={<p>Shortfall ({tableData.tableData.reduce(
                        (total: number, el: IBranchTargetsReport) => total + (Math.max(
                            (Number(el.no_Of_POs || "0") >= Number(el.min_Target || "0")) ? Number(el.max_Target || "0") - Number(el.no_Of_POs || "0") : Number(el.min_Target || "0") - Number(el.no_Of_POs || "0"),
                            0
                        )),
                        0
                    )})</p>}
                    body={shortfallTemplate}
                    style={{ minWidth: '180px' }}
                />

                <Column
                    header="Performance"
                    body={statusTemplate}
                    style={{ minWidth: '170px' }}
                />

                <Column
                    header="Remark"
                    body={remarkTemplate}
                    style={{ minWidth: '260px' }}
                />
            </DataTable>
        </>
    );
}